import IsEmpty from "./IsEmpty.js"

/**
 * @param value
 * @return {boolean}
 */
export default function NotEmpty(value) {
  return !IsEmpty(value)
}
